import { z } from "zod";
import { env as authEnv } from "@introw/auth/env";
import { env as apiEnv } from "@introw/api/env";
import { env as utilsEnv } from "@introw/utils/env";
import { createEnv } from "@t3-oss/env-nextjs";

export const env = createEnv({
  extends: [authEnv, apiEnv, utilsEnv],
  skipValidation: !!process.env.SKIP_ENV_VALIDATION,
  server: {
    PORT: z.coerce.number().optional(),
    HUBSPOT_APP_ID: z.string(),
    GTM_ID: z.string().optional(),
    INTERCOM_SECRET_KEY: z.string(),
    ZAPIER_INTERNAL_KEY: z.string().optional(),
    TINYBIRD_API_KEY: z.string().optional(),
    SLACK_BOT_SCOPE: z.string().optional().default(
      [
        // View basic information about public channels in the workspace.
        "channels:read",
        // View basic information about private channels which our bot was added to
        "groups:read",
        // Send messages as the bot.
        "chat:write",
        // Send messages to public channels bot isn't a member of.
        "chat:write.public",

        // Get user email to couple to introw user when they click on an action
        "users:read",
        "users:read.email",
      ].join(",")
    ),
    SLACK_USER_SCOPE: z.string().optional(),
    ENVIRONMENT: z.enum(["development", "staging", "production"]).default("development"),
    IMAGEKIT_API_KEY: z.string().default("public_ZsFXO0nfwiBUvaCgEp5Ba8nBSYQ="),
    IMAGEKIT_PRIVATE_KEY: z.string(),
    LEADFEEDER_API_KEY: z.string().optional(),
    SAML_PRIVATE_KEY: z.string().optional(),
    SAML_CERTIFICATE: z.string().optional(),
    SAML_ENCRYPTION_KEY: z.string().optional(),
    SAML_ENCRYPTION_CERTIFICATE: z.string().optional(),
    AZURE_PORTAL_AD_CLIENT_ID: z.string().optional(),
    AZURE_PORTAL_AD_CLIENT_SECRET: z.string().optional(),
    TRPC_API_URL: z.string().optional(),
    LANGFUSE_BASE_URL: z.string().optional(),
    LANGFUSE_SECRET_KEY: z.string().optional(),
    LANGFUSE_PUBLIC_KEY: z.string().optional(),
    IMGPROXY_KEY: z.string().optional(),
    IMGPROXY_SALT: z.string().optional(),
  },
  shared: {
    NODE_ENV: z.enum(["test", "development", "production"]).optional(),
    NEXT_PUBLIC_ROOMS_DOMAIN_URL: z.string(),
    NEXT_PUBLIC_PARTNERS_DOMAIN_URL: z.string(),
  },
  experimental__runtimeEnv: {
    NODE_ENV: process.env.NODE_ENV,
    NEXT_PUBLIC_ROOMS_DOMAIN_URL: process.env.NEXT_PUBLIC_ROOMS_DOMAIN_URL,
    NEXT_PUBLIC_PARTNERS_DOMAIN_URL: process.env.NEXT_PUBLIC_PARTNERS_DOMAIN_URL,
  },
});
